export const copyToClipboard = (content = "") => {
  return navigator.clipboard.writeText(content)
}